(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aztech-cockpit"] && !Shopify.designMode) return;
  try {
    
(function(){
const GENDERS=[
    {id:'homme',icon:'homme',vb:'0 0 100 120',label:'Homme',sub:'Collection homme',angle:180,desc:'La ligne homme — sportswear technique à l\'esprit aztèque, coupe athlétique.'},
    {id:'femme',icon:'femme',vb:'0 0 100 120',label:'Femme',sub:'Collection femme',angle:0,desc:'La ligne femme — matières performantes et silhouettes affûtées, signées de l\'aigle.'}
  ];
  const CATS=[
    {id:'tshirt',  icon:'tee',     vb:'0 0 100 110', label:'T-shirt',    sub:'Manches courtes',            desc:'La base. Coton lourd, coupe droite, emblème floqué.'},
    {id:'pants',   icon:'pants',   vb:'0 0 100 110', label:'Pants',      sub:'Bas · Joggers',              desc:'Coupe ajustée, taille élastiquée. Confort et allure.'},
    {id:'hoodies', icon:'hoodie',  vb:'0 0 100 110', label:'Hoodies',    sub:'Pulls à capuche',            desc:'Molleton gratté, capuche doublée, poche kangourou.'},
    {id:'jacket',  icon:'jacket',  vb:'0 0 100 110', label:'Jacket',     sub:'Bombers · Vestes',           desc:'Bomber technique, bords côtelés, zip AZTECH.'},
    {id:'ensemble',icon:'ensemble',vb:'0 0 100 110', label:'Ensemble',   sub:'2 en 1 · Hoodie + Jogging',  desc:'Le duo assorti hoodie + jogging. La silhouette complète.'},
    {id:'best',    icon:'eagle',   vb:'0 0 621 171', label:'Best Seller',sub:'Les incontournables',        desc:'Les pièces les plus prisées, signées de l\'aigle.'}
  ];
  const BACKS={tee:'tee-back',hoodie:'hoodie-back',pants:'pants-back',jacket:'jacket-back'};
  const PRICES={tshirt:['45 €','39 €','49 €','42 €'],pants:['65 €','59 €','69 €','75 €'],hoodies:['89 €','95 €','79 €','99 €'],jacket:['160 €','180 €','145 €','150 €'],ensemble:['140 €','150 €','129 €','160 €'],best:['45 €','89 €','65 €','160 €']};
  const NAMES={tshirt:['Tee « Eagle »','Tee Codex','Tee Temple','Tee Glyphe'],pants:['Jogger Codex','Pants Aztec','Jogger Pyramide','Cargo Temple'],hoodies:['Hoodie Pyramide','Hoodie Eagle','Hoodie Codex','Hoodie Temple'],jacket:['Bomber Eagle','Bomber Codex','Bomber Temple','Bomber Aztec'],ensemble:['Ensemble Codex','Ensemble Eagle','Ensemble Temple','Ensemble Pyramide'],best:['Tee « Eagle »','Hoodie Pyramide','Jogger Codex','Bomber Eagle']};

  const cons=document.getElementById('constellation');
  const rotor=document.getElementById('rotor');
  const hub=document.getElementById('hub');
  const R=()=>Math.min(300,(cons.clientWidth/2)-70);

  // (menu déroulant retiré — navigation via l'en-tête du thème + les orbiteurs)

  // ===== reticle tracking =====
  const fine=matchMedia('(pointer:fine)').matches, reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const reticle=document.getElementById('reticle');
  const exp=document.getElementById('exp'), targetEl=document.getElementById('target'), statusEl=document.getElementById('status');
  let mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my,inExp=false,locked=false;
  let cockpit='home', currentGender=null, currentCat=null;
  if(fine)(document.getElementById('aztech-cockpit')||document.body).classList.add('fine');
  exp.addEventListener('mouseenter',()=>{if(fine)reticle.classList.add('on');inExp=true;});
  exp.addEventListener('mouseleave',()=>{reticle.classList.remove('on');inExp=false;});
  window.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;},{passive:true});
  function loop(){if(!locked){rx+=(mx-rx)*.22;ry+=(my-ry)*.22;reticle.style.transform=`translate(${rx}px,${ry}px) translate(-50%,-50%)`;}requestAnimationFrame(loop);}
  if(fine)loop();

  // ===== cockpit (reused for accueil & genre) =====
  function orbData(){ return cockpit==='home'? GENDERS : CATS; }
  function setCockpit(mode){
    cockpit=mode;
    const home=(mode==='home');
    const hubIcon=home?{id:'eagle',vb:'0 0 621 171'}:(mode==='homme'?{id:'homme',vb:'0 0 100 120'}:{id:'femme',vb:'0 0 100 120'});
    hub.className='hub'+(home?'':' sym');
    hub.innerHTML=`<svg viewBox="${hubIcon.vb}" aria-hidden="true"><use href="#${hubIcon.id}"/></svg>`;
    rotor.classList.remove('spin');
    const items=home?GENDERS:CATS;
    const angles=home?items.map(g=>g.angle):items.map((_,i)=>-90+i*360/items.length);
    rotor.innerHTML=items.map((it,i)=>`<button class="orbiter" data-id="${it.id}" aria-label="${it.label}" style="--a:${angles[i]}"><div class="orb-spin"><div class="orb-breathe"><div class="orb-inner"><div class="oi"><svg viewBox="${it.vb}"><use href="#${it.icon}"/></svg></div></div></div><span class="orb-lbl">${it.label}</span></div></button>`).join('');
    place(); wireOrbiters();
    if(!home){ void rotor.offsetWidth; rotor.classList.add('spin'); }   // (re)start rotation in sync with the new icons
  }
  function place(){
    const r=R();
    document.querySelectorAll('.orbiter').forEach(el=>{
      const a=parseFloat(el.style.getPropertyValue('--a'))*Math.PI/180;
      el.style.setProperty('--x',(r*Math.cos(a)).toFixed(1)+'px');
      el.style.setProperty('--y',(r*Math.sin(a)).toFixed(1)+'px');
    });
  }
  window.addEventListener('resize',place);
  function wireOrbiters(){
    document.querySelectorAll('.orbiter').forEach(el=>{
      const id=el.dataset.id;
      el.addEventListener('mouseenter',()=>{if(locked)return;reticle.classList.add('aim');const it=orbData().find(x=>x.id===id);targetEl.textContent=(it?it.label:'').toUpperCase();statusEl.textContent='CIBLE ACQUISE';});
      el.addEventListener('mouseleave',()=>{if(locked)return;reticle.classList.remove('aim');targetEl.textContent='AUCUNE';statusEl.textContent='EN ATTENTE';});
      el.addEventListener('click',()=>{ if(cockpit==='home') enterGender(id); else enterProducts(id); });
    });
  }

  // ===== transitions (smooth cross-reveal, no black frame) =====
  function lockTo(it){
    targetEl.textContent=it.label.toUpperCase(); statusEl.textContent='VERROUILLAGE…';
    const orb=document.querySelector(`.orbiter[data-id="${it.id}"]`);
    if(orb){orb.classList.add('hot'); if(fine){const rc=orb.getBoundingClientRect();reticle.classList.remove('aim');reticle.classList.add('lock','on');reticle.style.transform=`translate(${rc.left+rc.width/2}px,${rc.top+rc.height/2}px) translate(-50%,-50%)`;}}
  }
  function cleanupLock(){reticle.classList.remove('lock','aim');document.querySelectorAll('.orbiter.hot').forEach(o=>o.classList.remove('hot'));targetEl.textContent='AUCUNE';statusEl.textContent='EN ATTENTE';}
  const stage=document.querySelector('.stage');
  function crossReveal(prepareNext, dir){        // dir:'fwd' (balaye vers l'avant) | 'back' (vers l'arrière)
    const src = catpage.classList.contains('show') ? catpage : exp;
    const rc = src.getBoundingClientRect();
    const cx = rc.left + rc.width/2, cy = rc.top + rc.height/2;
    const d = Math.hypot(rc.width, rc.height) * 1.2;
    const ghost = src.cloneNode(true);
    ghost.removeAttribute('id');
    ghost.classList.add('aztech-cockpit', 'ghost', dir);
    ghost.style.cssText += `position:fixed;left:${rc.left}px;top:${rc.top}px;width:${rc.width}px;height:${rc.height}px;min-height:0;margin:0;z-index:60`;
    document.body.appendChild(ghost);
    const ring = document.createElement('div');
    ring.className = 'sweepring ' + dir;
    ring.style.cssText = `left:${cx}px;top:${cy}px;--d:${d}px`;
    document.body.appendChild(ring);
    reticle.classList.remove('on');
    prepareNext();                                // next view rendered instantly underneath — page ne bouge pas
    setTimeout(()=>{ ghost.remove(); ring.remove(); cleanupLock(); locked=false; if(fine && !catpage.classList.contains('show')) reticle.classList.add('on'); }, 720);
  }
  function enterGender(id){
    if(locked)return; locked=true;
    const g=GENDERS.find(x=>x.id===id); currentGender=id;
    lockTo(g);
    if(reduce){ setCockpit(id); cleanupLock(); locked=false; return; }
    statusEl.textContent='ASPIRATION…';
    setTimeout(()=>crossReveal(()=>setCockpit(id),'fwd'), 240);
  }
  function enterProducts(id){
    if(locked)return; locked=true;
    const c=CATS.find(x=>x.id===id); currentCat=id;
    lockTo(c);
    if(reduce){ openProducts(c); cleanupLock(); locked=false; return; }
    statusEl.textContent='ASPIRATION…';
    setTimeout(()=>crossReveal(()=>openProducts(c),'fwd'), 240);
  }

  // ===== products page =====
  const catpage=document.getElementById('catpage'), catgrid=document.getElementById('catgrid');
  function openProducts(c){
    renderProducts(c);
    document.querySelector('.stage').style.display='none';
    catpage.classList.add('show'); reticle.classList.remove('on'); window.scrollTo({top:0,behavior:'auto'});
  }
  function setupMarquee(track){
    if(!track) return;
    const cont=track.parentElement, originals=Array.from(track.children), n=originals.length;
    if(!n) return;
    const gap=14, setW=track.scrollWidth, period=setW+gap;
    let s=0;
    while(track.scrollWidth < cont.clientWidth + period && s<12){ originals.forEach(c=>track.appendChild(c.cloneNode(true))); s++; }
    track.style.setProperty('--period', period+'px');
    const speed=45; // px/s (lent)
    track.style.setProperty('--dur', Math.max(18, period/speed).toFixed(1)+'s');
  }
  function mountCards(cardsHTML){
    if(!cardsHTML){ catgrid.className='catgrid'; catgrid.innerHTML=''; return; }
    if(reduce){ catgrid.className='catgrid'; catgrid.innerHTML=cardsHTML; return; }
    catgrid.className='catcarousel';
    catgrid.innerHTML='<div class="cattrack">'+cardsHTML+'</div>';
    requestAnimationFrame(()=>setupMarquee(catgrid.querySelector('.cattrack')));
  }
  function renderProducts(c){
    const g=GENDERS.find(x=>x.id===currentGender);
    document.getElementById('backlabel').textContent='Retour · '+(g?g.label:'');
    document.getElementById('cattitle').textContent=c.label;
    document.getElementById('catsub').textContent=(g?g.label+' · ':'')+'Rayon '+c.sub;
    document.getElementById('catdesc').textContent=c.desc;
    document.getElementById('crumb').textContent='AZTECH / '+(g?g.label.toUpperCase()+' / ':'')+c.label.toUpperCase();
    const wm=document.getElementById('catwm'); wm.setAttribute('viewBox',c.vb); wm.innerHTML=`<use href="#${c.icon}"/>`;
    // 1) vrais produits Shopify
    const cat = (window.AZTECH_CATALOG && window.AZTECH_CATALOG[c.id]) || null;
    if(cat){
      const items = cat.filter(p => p.g==='both' || !currentGender || p.g===currentGender);
      if(items.length){
        const cardsHTML = items.map(p=>{
          const front = p.f ? `<img src="${p.f}" alt="${p.t}" loading="lazy">` : `<svg viewBox="${c.vb}"><use href="#${c.icon}"/></svg>`;
          const back  = p.b ? `<img src="${p.b}" alt="${p.t}" loading="lazy">` : front;
          return `<a class="ccard" href="${p.u}"><div class="ph"><div class="flip"><div class="face front">${front}</div><div class="face back">${back}</div></div></div><div class="meta"><span class="nm">${p.t}</span><span class="pr">${p.p}</span></div></a>`;
        }).join('');
        mountCards(cardsHTML);
      } else {
        catgrid.className='catgrid';
        catgrid.innerHTML = `<div class="cat-empty">Aucun produit${g?' « '+g.label+' »':''} dans cette catégorie pour l'instant.</div>`;
      }
      return;
    }
    // 2) repli : placeholders
    const back=BACKS[c.icon]||c.icon;
    const cardsHTML=NAMES[c.id].map((n,i)=>`<div class="ccard"><div class="ph"><div class="flip"><div class="face front"><svg viewBox="${c.vb}"><use href="#${c.icon}"/></svg></div><div class="face back"><svg viewBox="${c.vb}"><use href="#${back}"/></svg></div></div></div><div class="meta"><span class="nm">${n}</span><span class="pr">${PRICES[c.id][i]}</span></div></div>`).join('');
    mountCards(cardsHTML);
  }

  // ===== back nav =====
  function backToGender(){
    catpage.classList.remove('show'); document.querySelector('.stage').style.display='';
    window.scrollTo({top:0,behavior:'auto'}); locked=false;
  }
  function goHome(){
    if(cockpit==='home' && !catpage.classList.contains('show')){locked=false;cleanupLock();return;}
    if(locked)return; locked=true;
    if(reduce){ if(catpage.classList.contains('show')){catpage.classList.remove('show');stage.style.display='';} setCockpit('home'); currentGender=null; cleanupLock(); locked=false; return; }
    crossReveal(()=>{
      if(catpage.classList.contains('show')){catpage.classList.remove('show');stage.style.display='';}
      setCockpit('home'); currentGender=null;   // le logo revient au milieu (aigle)
    },'back');
  }
  document.getElementById('backbtn').addEventListener('click',backToGender);
  document.getElementById('cathome').addEventListener('click',e=>{e.preventDefault();goHome();});
  document.getElementById('navhome').addEventListener('click',e=>{e.preventDefault();goHome();});
  hub.addEventListener('click',()=>{ if(cockpit!=='home' && !locked) goHome(); });

  // init
  setCockpit('home');
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
